import { FC, useContext } from 'react';
import {
  Group,
  Text,
  Button,
  Title,
  Stack,
  Loader,
  Anchor,
} from '@mantine/core';
import { IconDownload } from '@tabler/icons-react';
import { useDeviceType } from 'hooks/useDeviceType';
import UpgradeOverlay from './UpgradeOverlay';
import { ICallHistoryTableData } from '.';
import { TableGroup } from './TabletViewComponents';

import classes from './index.module.scss';
import AuthContext from 'context/AuthContext';
import { AccessLevel } from 'interfaces/GetUserResult';

interface CallHistoryTableTabletViewProps {
  data: ICallHistoryTableData[];
  onViewDetails: (id: string) => void;
  onExport: () => void;
  isLoading?: boolean;
  isDownloading?: boolean;
}

const CallHistoryTableTabletView: FC<CallHistoryTableTabletViewProps> = ({
  data,
  onViewDetails,
  onExport,
  isLoading,
  isDownloading,
}) => {
  const { isMobile } = useDeviceType();
  const {
    data: { account },
  } = useContext(AuthContext);
  const isPremium = account?.access_level === AccessLevel.PRO;

  return (
    <>
      <Group justify="space-between" className={classes.header}>
        <Title size="1rem" fw={700}>
          Call detail history
        </Title>
        <Button
          variant="transparent"
          size="sm"
          fw={400}
          p={0}
          disabled={
            isDownloading || isLoading || data.length === 0 || !isPremium
          }
          onClick={onExport}
          style={{ opacity: isDownloading ? 0.6 : 1 }}
          bg="none"
          rightSection={
            isDownloading ? (
              <Loader size="0.75rem" style={{ marginLeft: '0.7rem' }} />
            ) : (
              <IconDownload
                size={19}
                stroke={1.5}
                style={{ marginLeft: '0.25rem', marginBottom: '0.2rem' }}
              />
            )
          }
        >
          {isMobile ? 'Export' : 'Export call history'}
        </Button>
      </Group>
      <Stack gap="sm">
        {data.length === 0 && !isLoading && (
          <Text c="dimmed" fz="sm">
            No call data available for the selected date range
          </Text>
        )}
        {data.map((record) => {
          return (
            <UpgradeOverlay key={record.id}>
              <Anchor
                style={{
                  cursor: record.isIncomplete ? 'not-allowed' : 'pointer',
                  pointerEvents: record.isIncomplete ? 'none' : 'auto',
                }}
                onClick={() =>
                  record.isIncomplete ? null : onViewDetails(record.id)
                }
              >
                <TableGroup record={record} />
              </Anchor>
            </UpgradeOverlay>
          );
        })}
        {isLoading && <TableGroup isLoading={true} />}
      </Stack>
    </>
  );
};

export default CallHistoryTableTabletView;
